<!--
 * @author: JJ
 * @since: 2024-10-08
 * Billing.vue
-->
<template>
    <div class="container">
        <Header />
        <div class="top_nav ptb10">
            <div class="w1400 flex-box">
                <img src="../../assets/static/images/jj_logo_new.png" @click="toIndex" class="logo cursor" alt="">
                <div class="flex-grow-1 pl60">
                    <div class="pl60 top_title fs18">订单</div>
                </div>
            </div>
        </div>
        <div class="w1400 mt25 fs14 cursor"><span class="col90">当前位置：</span><router-link to="/" class="col04">首页
                /</router-link><router-link to="/Cart" class="col04">
                订单 /</router-link><span class="now_page"> 结算</span></div>
        <div class="mt15 w1400 flex-box">
            <div class="col04 fs18 fwb">确认订单信息</div>
            <div class="pl10 col90">请在<span class="zprice1">{{ auto_close }}</span>分钟内完成支付，否则订单会被自动取消。</div>
        </div>
        <div class="address_box w1400">
            <div class="flex-box">
                <div class="fs16 fwb col04 flex-grow-1">收货地址</div>
                <!-- <div class="col90 fs16 cursor" @click="addressManage">管理地址</div> -->
            </div>
            <div class="fs18" v-if="addressList.length <= 0">
                您还没有添加地址哦
            </div>
            <template v-else :key="index" v-for="(item, index) in addressList">
                <div @click="changeAddress(item)" v-if="showAddress ? true : index < 2" class="address_link flex cursor"
                    :class="orderPayload.address_id == item.id ? 'ac' : ''">
                    <img v-if="orderPayload.address_id == item.id" src="../../assets/static/icon/jj_address_sc.png"
                        class="ico24" alt="">
                    <img v-else src="../../assets/static/icon/jj_address_nor.png" class="ico24" alt="">
                    <div class="flex-grow-1 pl20">
                        <div class="fwb col27 fs16 lh20">{{ item.province_name + item.city_name +
                            item.district_name + item.address }}</div>
                        <div class="mt15 col27 fs14">{{ item.consignee }} {{ item.mobile }}</div>
                    </div>
                </div>
            </template>
        </div>
        <div class="mtb15 goods_box w1400" v-if="orderInfo.goods_list.length > 0">
            <div class="col04 fwb fs16">商品信息</div>
            <div class="goods_tab col04 tc fs16 flex-box">
                <div class="w144"></div>
                <div class="w258  ">商品</div>
                <div class="w110">规格</div>
                <div class="w196">单价(元)</div>
                <div class="w131">优惠</div>
                <div class="flex-grow-1">数量</div>
                <div class="flex-grow-1">小计(元)</div>
            </div>
            <div class="goods_link flex-box" v-for="(item, index) in orderInfo.goods_list" :key="index">
                <img :src="item.goods.image_text" class="w144" alt="">
                <div class="w258 col04 fs14 lh22 m-ellipsis-l2">
                    <!-- <temlpate v-if="item.activity">
                        <span class="tips lq_tips" v-if="item.activity.type == 'expiry_food'">临期</span>
                        <span class="tips" v-else>{{ item.activity.title }}</span>
                    </temlpate> -->
                    {{ item.goods.title }}
                </div>
                <div class="w110 tc fs14 col04">
                    {{ item.current_sku_price.goods_sku_text }}
                </div>
                <div class="w196 tc fs14 col90">{{ item.current_sku_price.price }}</div>
                <div class="w131 flex-box flex-center">
                    <img src="../../assets/static/icon/jj_arrow_down.png" class="arrow_down" alt="">
                    <div class="pl5 coleb fs14" :class="false ? 'coleb' : 'cold8'">0</div>
                </div>
                <div class="flex-grow-1 tc fs14 col27">× {{ item.goods_num }}</div>
                <div class="flex-grow-1 tc fs14 coleb fwb">{{ item.goods_amount }}</div>
            </div>
        </div>
        <div v-else class="nodata fs16 tc">
            <img src="../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
            <div>暂无相关数据</div>
        </div>
        <template
            v-if="orderPayload.buy_type == 'activity' && orderPayload.goods_list[0].activity_type == 'new_sample'">
            <div class="pay_box w1400">
                <div class="col04 fwb fs16 mb25">打版是否需要线下指导</div>
                <div class="flex-box">
                    <div class="flex-box bb flex-grow-1 cursor" @click="checkneed(0)">
                        <img v-if="needIndex == 0" src="../../assets/static/icon/jj_radio_sc.png" class="ico20" alt="">
                        <img v-else src="../../assets/static/icon/jj_radio_uc.png" class="ico20" alt="">
                        <div class="pl25 fs16 col04">不需要</div>
                    </div>
                    <div class="flex-box bb ml30 flex-grow-1 cursor" @click="checkneed(1)">
                        <img v-if="needIndex == 1" src="../../assets/static/icon/jj_radio_sc.png" class="ico20" alt="">
                        <img v-else src="../../assets/static/icon/jj_radio_uc.png" class="ico20" alt="">
                        <div class="pl25 fs16 col04">需要</div>
                    </div>
                </div>
                <div class="input_box" v-if="needIndex == 1">
                    <div class="flex-box bb">
                        <p class="fs16 fwb">联系人</p>
                        <input type="text" class="flex-grow-1 tl pl30 fs16" v-model="new_sample.contact"
                            placeholder="请输入打版联系人">
                    </div>
                    <div class="flex-box bb">
                        <p class="fs16 fwb">联系方式</p>
                        <input type="number" maxlength="11" class="flex-grow-1 fs16 tl pl30"
                            v-model="new_sample.contact_mobile" placeholder="请输入打版联系人">
                    </div>
                </div>
            </div>
        </template>
        <div class="pay_box w1400">
            <div class="col04 fwb fs16 mb25">支付方式</div>
            <div>
                <div class="pay_link cursor" @click="choosepay('wechat')">
                    <img src="../../assets/static/icon/jj_radio_sc.png" v-if="payment == 'wechat'" class="ico20" alt="">
                    <img src="../../assets/static/icon/jj_radio_uc.png" v-else class="ico20" alt="">
                    <img src="../../assets/static/icon/jj_wepay.png" class="ico_wepay" alt="">
                    <div class="pl25 fs16 col04">微信支付</div>
                </div>
                <div class="pay_link cursor ml20" @click="choosepay('duigong')"
                    v-if="orderPayload.buy_type !== 'activity' || (orderPayload.goods_list[0].activity_type !== 'groupon' && orderPayload.goods_list[0].activity_type !== 'new_sample')">
                    <img src="../../assets/static/icon/jj_radio_sc.png" v-if="payment == 'duigong'" class="ico20"
                        alt="">
                    <img src="../../assets/static/icon/jj_radio_uc.png" v-else class="ico20" alt="">
                    <img src="../../assets/static/icon/jj_icard.png" class="ico_icard" alt="">
                    <div class="pl25 fs16 col04">公对公付款</div>
                </div>
            </div>
            <!-- 新增积分抵扣 -->
            <div v-if="orderPayload.buy_type !== 'activity'" @click="onUseScore()"
                class=" pay_link2 flex-box mt20 cursor">
                <img src="../../assets/static/icon/jj_radio_sc.png" v-if="orderPayload.use_score" class="ico20 " alt="">
                <img src="../../assets/static/icon/jj_radio_uc.png" v-else class="ico20 cursor" alt="">
                <div class="flex-grow-1 pl25 fs16">
                    <div class="col04  mb10 ">
                        使用积分抵扣
                    </div>
                    <div class="">
                        账户还剩<span class="blue">{{ orderInfo.myscore }}</span>积分，可使用<sapn class="blue">{{
                            orderInfo.score_amount
                            }}</sapn>积分，可抵扣<span class="col-red">¥{{ orderInfo.score_fee }}</span>
                    </div>
                </div>
            </div>
            <div class="flex-box mt40">
                <template v-if="orderPayload.buy_type == 'activity'">
                    <img @click="onActivityCheck" v-if="activityAgree" src="../../assets/static/icon/jj_radio_sc.png"
                        class="ico20 cursor" alt="">
                    <img @click="onActivityCheck" v-else src="../../assets/static/icon/jj_radio_uc.png"
                        class="ico20 cursor" alt="">
                    <div class="flex-grow-1 fs14 col04 ml15">已阅读并同意
                        <span class="fs12 cursor col127" @click.stop="onAgreement('activity_newsample_agreement')" v-if="orderInfo.activity_agreement.includes('new_sample')">《新品条款》</span>
                        <span class="fs12 cursor col127" @click.stop="onAgreement('activity_seckill_agreement')" v-if="orderInfo.activity_agreement.includes('seckill')"> 《限时购条款》</span>
                        <span class="fs12 cursor col127" @click.stop="onAgreement('activity_groupon_agreement')" v-if="orderInfo.activity_agreement.includes('groupon')"> 《拼团条款》</span>
                        <span class="fs12 cursor col127" @click.stop="onAgreement('activity_expire_food_agreement')" v-if="orderInfo.activity_agreement.includes('expiry_food')"> 《临期条款》</span>
                    </div>
                </template>
                <div class="flex-grow-1  flex-box flex-end" v-if="orderInfo.pay_fee > 0">
                    <div class="col90 fs16">已选{{ orderInfo.goods_list.length }}款 共{{ totalNum }}件</div>
                    <div class="ml15 fs16 col04"> 需付金额：</div>
                    <div class="fs16 coleb">¥<span class="fs18 coleb">{{ orderInfo.pay_fee }}</span></div>
                </div>

            </div>
            <!-- <router-link class="btn_submit cursor" to="/Checkout" v-if="payi == 0">提交订单</router-link>
            <router-link class="btn_submit cursor" to="/Corporate" v-if="payi == 1">提交订单</router-link> -->
            <el-button class="btn_submit cursor" :disabled="createOrderStatus" :loading="createOrderStatus"
                @click="onConfirm">提交订单</el-button>
        </div>
        <!--《活动条款》弹窗  -->
        <popup :visible="sucPop" @close="sucPop = false">
            <div class="popup">
                <div class="tc fs16 col3 tc lh34 mb45">《{{article.name}}》</div>
                <div class="line2"></div>
                <div class="popup_main" v-html="article.content"></div>
                <div @click="sucPop = false" class="fs16 col3 tc close_btn cursor">关闭</div>
            </div>
        </popup>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useHead } from '@unhead/vue'
onMounted(() => {
    useHead({
        title: "下单-小狮优选",
        meta: [
            { name: "description", content: "This is my page description" },
            { property: "og:title", content: "My Page Title" },
            { property: "og:description", content: "This is my page description" },
            { property: "og:url", content: "https://example.com/my-page" },
            { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    })
})
</script>
<script>
export default {
    data() {
        return {
            article: { content: '' },
            addressList: [{}],//地址
            showAddress: false,//是否显示全部地址
            state: 2, //1拼团  2新品体验 3秒杀
            activityAgree: false,
            orderInfo: { //商品信息
                goods_list: [],
                activity_agreement: []
                //promo_infos: []
            },
            payment: 'wechat',
            orderPayload: {
                buy_type: 'general',
                coupon_id: 0,
                from: '',
                goods_list: []
            },
            new_sample: {
                contact: '',
                contact_mobile: ''
            },
            corporateAccount: [], //对公
            auto_close: 0,
            createOrderStatus: false,
            sucPop: false,

            needIndex: 0
        }
    },
    created() {
        this.orderPayload = JSON.parse(decodeURIComponent(this.$route.query.data));
        this.changeConsignee();
    },
    mounted() {
        if (this.$cookies.get("token")) {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
        this.auto_close = this.$root.$data.config.app.auto_close; //关闭时间
        this.fetchAddress();
    },
    computed: {
        totalNum() {
            let total = 0;
            this.orderInfo.goods_list.forEach((item) => {
                total += item.goods_num;
            });
            return total;
        },
    },
    methods: {
        toIndex() {
            this.$router.push('/')
        },
        //是否使用积分抵扣
        onUseScore() {
            this.orderPayload.use_score = !this.orderPayload.use_score;
            this.$forceUpdate();
            this.getOrderInfo();
        },
        //获取地址列表
        fetchAddress() {
            let that = this;
            that.$api.Address().then(res => {
                that.addressList = res.data;
            })
        },
        // 选择地址
        changeAddress(address) {
            console.log(address);
            this.changeConsignee(address);
        },
        // 展示全部地址
        clickAllAddress() {
            this.showAddress = !this.showAddress
        },
        //活动条款
        onActivityCheck() {
            this.activityAgree = !this.activityAgree
        },
        onAgreement(type) {
            
            let id = this.$root.$data.config.app[type];
            this.$api.getAgreement({ id: id }).then(ret => {
                this.article = ret.data;
                this.sucPop = true
            })
        },
        checkneed(index) {
            this.needIndex = index;
        },
        // 检查库存&计算订单价格
        getOrderInfo() {
            let that = this;
            that.$api.GetOrderCalc(
                that.orderPayload
            ).then(res => {
                that.orderInfo = res.data.order;
                that.corporateAccount = res.data.corporate_account;
            },)
        },
        // 更改收货人地址&计算订单信息
        changeConsignee(addressInfo = {}) {
            if (Object.keys(addressInfo).length <= 0) {
                this.$api.GetAddress(
                ).then(res => {
                    this.addressInfo = res.data;
                    this.orderPayload.address_id = this.addressInfo ? this.addressInfo.id : 0;
                })
            }
            if (Object.keys(addressInfo).length > 0) {
                this.addressInfo = addressInfo;
                this.orderPayload.address_id = this.addressInfo.id;
            }
            this.getOrderInfo();
        },
        //地址管理
        addressManage() {
            this.$router.push('/Address')
        },
        //支付方式
        choosepay(pay) {
            this.payment = pay;
        },

        // 提交订单/立即兑换
        onConfirm() {
            let that = this;
            if (!this.orderPayload.address_id && this.orderInfo.need_address === 1) {
                that.$message({
                    customClass: 'custom-message',
                    message: "请选择收货地址",
                    type: "error",
                    duration: 3000,
                });
                return;
            }
            if (this.needIndex == 1) {
                console.log(this.new_sample.contact, this.new_sample.contact_mobile)
                if (this.new_sample.contact.trim() == '' || this.new_sample.contact_mobile == '') {
                    that.$message({
                        customClass: 'custom-message',
                        message: "请填写联系内容",
                        type: "error",
                        duration: 3000,
                    });
                    return;
                }
                this.orderPayload.need_contact = 1;
                this.orderPayload.contact = this.new_sample.contact;
                this.orderPayload.contact_mobile = this.new_sample.contact_mobile;
            } else {
                this.orderPayload.need_contact = 0;
                this.orderPayload.contact = '';
                this.orderPayload.contact_mobile = '';
            }
            if (this.orderPayload.buy_type === 'activity' && !this.activityAgree) {
                that.$message({
                    customClass: 'custom-message',
                    message: "请同意活动协议",
                    type: "error",
                    duration: 3000,
                });
                return;
            }
            this.orderPayload.pay_mode = this.payment;
            this.submitOrder();
        },
        //下单
        submitOrder() {
            this.createOrderStatus = true;
            let orderPayload = this.orderPayload;
            orderPayload.showToast = true;
            this.$api.CreateOrder(orderPayload).then(ret => {
                console.log(ret.data)
                // 更新购物车列表
                if (this.orderPayload.from === 'cart') {
                    // uni.$emit(getApp().globalData.Event.CartRefresh, {});
                }
                let orderSn = [];
                ret.data.forEach(order => {
                    orderSn.push(order.order_sn);
                })
                if (this.payment == 'duigong') {
                    //对公付款不需要生成支付流水
                    let data = JSON.stringify({
                        orderSN: orderSn.join(','),
                        payment: this.payment,
                        payState: 'success',
                        orderType: this.orderPayload.order_type,
                        buyType: this.orderPayload.buy_type || ''
                    })
                    this.$router.replace({ path: '/Corporate', query: { data: encodeURIComponent(data) } });
                    return;
                }
                if (ret.data[0].status === 'paid') {
                    let data = JSON.stringify({
                        orderSN: orderSn.join(','),
                        payment: this.payment,
                        payState: 'success',
                        orderType: this.orderPayload.order_type,
                        buyType: this.orderPayload.buy_type || ''
                    })
                    this.$router.replace({ path: '/Checkout', query: { data: encodeURIComponent(data) } });
                } else {
                    //前往支付
                    this.payResult('paying', orderSn.join(','), this.payment, 'goods');
                }
            }).catch(ret => {
                this.createOrderStatus = false;
                this.$confirm(ret.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    // this.$router.go(-1);
                });
            })
        },

        payResult(resultType, orderSn, payment, orderType) {
            let data = JSON.stringify({
                orderSN: orderSn,
                payment: payment, //重新支付的时候x使用
                payState: resultType,
                orderType: orderType,
                buyType: this.orderPayload.buy_type || ''
            })
            this.$router.replace({ path: '/Checkout', query: { data: encodeURIComponent(data) } });
        }

    }
}
</script>
<style lang="less" scoped>
.top_nav {
    width: 100%;
    background: #f9f9f9;

    .logo {
        width: 170px;
        height: auto;
    }

    .pl60 {
        padding-left: 60px;
    }

    .top_title {
        padding-left: 60px;
        font-weight: 500;
        color: #040404;
        height: 100px;
        line-height: 100px;
        position: relative;

        &::before {
            content: '';
            width: 2px;
            height: 101px;
            background: rgba(98, 134, 171, 0.4);
            display: inline-block;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}

.col127 {
    color: #1275FF;
}

.cu {
    cursor: pointer;
}

.mt40 {
    margin-top: 40px;
}

.address_box {

    padding: 20px 30px;
    background: #FFFFFF;
    margin-left: auto;
    margin-right: auto;
    margin-top: 15px;

    .address_link {
        width: calc(50% - 20px);
        border-radius: 8px;
        border: 2px solid rgba(98, 134, 171, 0.2);
        margin-top: 20px;
        display: inline-flex;
        vertical-align: top;
        padding-left: 24px;
        padding-right: 40px;
        margin-right: 20px;
        padding-top: 24px;
        padding-bottom: 24px;

        &:nth-of-type(2n) {
            margin-right: 0;
        }

        &.ac {
            border: 2px solid #3D7EFE;
        }
    }
}

.ico24 {
    width: 24px;
    height: 28px;
    display: block;
}

.ico15 {
    width: 15px;
    height: auto;
    margin-left: 10px;
}

.goods_box {

    background: #FFFFFF;
    padding: 20px 30px;
    margin-left: auto;
    margin-right: auto;

    .goods_tab {
        width: 100%;
        height: 46px;
        background: #FAFCFF;
        margin-top: 15px;
        padding-left: 44px;
        padding-right: 44px;
    }
}

.goods_link {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(98, 134, 171, 0.4);
    padding-left: 44px;
    padding-right: 44px;
}

.w144 {
    width: 60px;
}

.w258 {
    width: 258px;
    margin-left: 27px;
    margin-right: 27px;
}

.w110 {
    width: 110px;
}

.w196 {
    width: 196px;
}

.w131 {
    width: 131px;
}

.tips,
.lq_tips {
    width: 44px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    padding-left: 5px;
    padding-right: 5px;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(153deg, #ff4d4d 0%, #ff652d 100%);
    margin-bottom: 6px;
    margin-right: 10px;
}

.lq_tips {
    background: linear-gradient(117deg, #3D6CFE 0%, #4AC3FC 100%);
}


.arrow_down {
    width: 10px;
    height: auto;
}

.coleb {
    color: #EB3F25;
}

.pay_box {

    background: #FFFFFF;
    margin-bottom: 0.2rem;
    padding: 20px 30px;
    margin-left: auto;
    margin-right: auto;
}

.mb25 {
    margin-bottom: 25px;
}

.pay_link,
.pay_link2 {
    width: 400px;
    height: 132px;
    border-radius: 8px;
    border: 2px solid rgba(98, 134, 171, 0.2);
    padding-left: 44px;
    padding-right: 44px;
    display: inline-flex;
    align-items: center;
    vertical-align: top;

    .ico_wepay {
        width: 62px;
        height: auto;
        margin-left: 20px;
    }

    .ico_icard {
        width: 60px;
        height: auto;
        margin-left: 20px;
    }
}

.pay_link2 {
    width: 820px;
}

.pay_link2 {
    div {
        display: block;
    }

}

.ico20 {
    width: 20px;
    height: auto;
}

.btn_submit {
    margin-top: 40px;
    margin-left: auto;
    margin-right: 0;
    width: 108px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    background: #1275FF;
    border-radius: 6px;
    display: block;
    padding: 0;
}

.popup {
    width: 1400px;
    padding: 106px 120px 80px;
    background: #ffffff;
    box-shadow: 0px 2px 32px 0px rgba(0, 0, 0, 0.23);
    border-radius: 20px;
}

.line2 {
    width: 1160px;
    height: 1px;
    background: repeating-linear-gradient(to right,
            rgba(51, 51, 51, 0),
            rgba(51, 51, 51, 1),
            rgba(51, 51, 51, 0));
    margin: 0 auto 45px;
}

.popup_main {
    height: 50vh;
    overflow-y: scroll;
    margin: 0 auto 77px;
}

.close_btn {
    width: 398px;
    text-align: center;
    line-height: 64px;
    height: 66px;
    border-radius: 41px;
    border: 1px solid #b0b0b0;
    margin: 0 auto;
}

.bb {
    padding: 30px 20px;
    border-bottom: 1px solid #b0b0b0;
}

.input_box {
    padding: 0 30px 30px;
    background: #f9f9f9;
    margin-top: 30px;

    p {
        color: #1275FF;
        width: 100px;
    }
}
</style>
